// export const appid = 'wx80bf2fa34f61921a'

import { showToast } from "@nutui/nutui"

export const getCode = () => {
  // let wx_code = getUrlParam('code')
  let user_appid = 'wx80bf2fa34f61921a' //个人开发者appid
  let local = window.location.href //重定向地址
  // let local = 'https://huitou-admin.maylandmall.cn/mall'

  //苹果系统 IPAD 系统
  if (navigator.userAgent.match(/iPhone|iPod|iPad/i)) {
    let localUrl = local.split('#')[0]
    localStorage.setItem('localUrl', localUrl)
  }
  
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${user_appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
  // call(wx_code)
  // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx80bf2fa34f61921a&redirect_uri=https://huitou-admin.maylandmall.cn/mall&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`

/**
 * https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx80bf2fa34f61921a&redirect_uri=https://huitou-admin.maylandmall.cn/mall&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect
 */
}

/**
 * 截取code
 */

export const getUrlParam = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// /**
//  * 
//  * @returns 重新获取code 
//  */

//判断当前环境是否为微信环境
export const isWeiXinLogin = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  // console.log('ua============',ua);
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    let code = getUrlParam('code')
    if (!code) {
      getCode()
    }
    return true // 微信中打开
  } else {
    // showToast.info({
    //   message: '请在微信中打开',
    // });
    return false // 普通浏览器中打开
  }
}
